"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _unique = _interopRequireDefault(require("../helpers/unique.id"));

var _accordion = _interopRequireDefault(require("./accordion"));

var _accordionItemStateful = require("./accordionItemStateful");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AccordionStateful =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AccordionStateful, _React$Component);

  function AccordionStateful(props) {
    var _this;

    _classCallCheck(this, AccordionStateful);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AccordionStateful).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getInitialState", function (children, accordionId, multiple) {
      var childrenArr = _react.default.Children.toArray(children);

      var hasOneActive = false;
      return childrenArr.reduce(function (newState, item, index) {
        var idItem = item.props.id || "".concat(accordionId, "-").concat(index);
        var isActive = item.props.defaultActive;

        if (!multiple) {
          isActive = !hasOneActive && item.props.defaultActive;
          hasOneActive = isActive || hasOneActive;
        }

        return _objectSpread({}, newState, _defineProperty({}, idItem, isActive));
      }, {});
    });

    _defineProperty(_assertThisInitialized(_this), "itemClick", function (id) {
      var activeItem = _this.state.active;
      var newState = {
        active: _objectSpread({}, activeItem, _defineProperty({}, id, !activeItem[id]))
      };

      if (!_this.props.multiple) {
        Object.keys(activeItem).forEach(function (item) {
          if (item !== id) newState.active[item] = false;
        });
      }

      _this.setState(newState, _this.props.onChange(newState.active));
    });

    _defineProperty(_assertThisInitialized(_this), "processedChildren", function (children) {
      var childrenArr = _react.default.Children.toArray(children);

      return childrenArr.map(function (item, index) {
        var itemId = item.props.id || "".concat(_this.accordionId, "-").concat(index);
        return _react.default.cloneElement(item, {
          active: _this.state.active[itemId],
          id: itemId
        });
      });
    });

    _this.accordionId = _this.props.id || (0, _unique.default)();

    var initialState = _this.getInitialState(props.children, _this.accordionId, _this.props.multiple);

    _this.state = {
      active: initialState
    };
    return _this;
  }

  _createClass(AccordionStateful, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_accordion.default, _extends({}, this.props, {
        onChange: this.itemClick
      }), this.processedChildren(this.props.children));
    }
  }]);

  return AccordionStateful;
}(_react.default.Component);

var exclusiveArrowProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('leftArrow', 'inlineArrow');
var exclusiveBackgroundProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('background', 'transparent');
var exclusiveBorderProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('borderless', 'borderBottom');
AccordionStateful.defaultProps = {
  onChange: function onChange() {}
};
var AccordionPropTypesDependency = {
  /** {bool} Mutually exclusive props: @@background@@ @@transparent@@ */
  background: exclusiveBackgroundProps,

  /** {bool} Mutually exclusive props: @@background@@ @@transparent@@ */
  transparent: exclusiveBackgroundProps,

  /** {bool} Mutually exclusive props: @@leftArrow@@ @@inlineArrow@@ */
  leftArrow: exclusiveArrowProps,

  /** {bool} Mutually exclusive props: @@leftArrow@@ @@inlineArrow@@ */
  inlineArrow: exclusiveArrowProps,

  /** {bool} Mutually exclusive props: @@borderless@@ @@borderBottom@@ */
  borderless: exclusiveBorderProps,

  /** {bool} Mutually exclusive props: @@borderless@@ @@borderBottom@@ */
  borderBottom: exclusiveBorderProps
};
AccordionStateful.propTypes = _objectSpread({
  /** {---} Sequence of: @@<AccordionStateful.Item>@@ (required, min: 1) */
  children: _propTypes.node.isRequired,
  id: _propTypes.string,
  onChange: _propTypes.func,
  defaultActive: _propTypes.bool,
  multiple: _propTypes.bool
}, AccordionPropTypesDependency);
AccordionStateful.Item = _accordionItemStateful.AccordionItemStateful;
var _default = AccordionStateful;
exports.default = _default;
AccordionStateful.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "getInitialState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "children",
      "type": null
    }, {
      "name": "accordionId",
      "type": null
    }, {
      "name": "multiple",
      "type": null
    }],
    "returns": null
  }, {
    "name": "itemClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "processedChildren",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "children",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "AccordionStateful",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": "{---} Sequence of: @@<AccordionStateful.Item>@@ (required, min: 1)"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "defaultActive": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "multiple": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "background": {
      "type": {
        "name": "custom",
        "raw": "exclusiveBackgroundProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@background@@ @@transparent@@"
    },
    "transparent": {
      "type": {
        "name": "custom",
        "raw": "exclusiveBackgroundProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@background@@ @@transparent@@"
    },
    "leftArrow": {
      "type": {
        "name": "custom",
        "raw": "exclusiveArrowProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@leftArrow@@ @@inlineArrow@@"
    },
    "inlineArrow": {
      "type": {
        "name": "custom",
        "raw": "exclusiveArrowProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@leftArrow@@ @@inlineArrow@@"
    },
    "borderless": {
      "type": {
        "name": "custom",
        "raw": "exclusiveBorderProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@borderless@@ @@borderBottom@@"
    },
    "borderBottom": {
      "type": {
        "name": "custom",
        "raw": "exclusiveBorderProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@borderless@@ @@borderBottom@@"
    }
  }
};